import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetDataAlertsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setDataAlertsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
